import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { GetPerformanceQuery, PerformanceFormFillsDataResponse } from '../types';
import { usePerformanceFormFillsRequest } from './usePerformanceRequests';

const useGetFormFillBacklogAgeing = (query?: GetPerformanceQuery) => {
    const [processedData, setProcessedData] =
        React.useState<PerformanceFormFillsDataResponse['backlog_reports']>();
    const { data } = usePerformanceFormFillsRequest(query);

    const [searchParams] = useSearchParams();
    const state = searchParams.get('state');

    React.useEffect(() => {
        if (!data) return;

        const filteredData = state
            ? data.backlog_reports.filter((item) => state.split(',').includes(item.state))
            : data.backlog_reports;

        const calculatedData = filteredData.reduce((acc, row) => {
            const existingWeek = acc.find(
                (item: PerformanceFormFillsDataResponse['backlog_reports'][number]) =>
                    item.week_start === row.week_start
            );

            if (existingWeek) {
                existingWeek.count += 1;
                existingWeek.open_form_fills_0_to_7_days += row.open_form_fills_0_to_7_days;
                existingWeek.open_form_fills_7_to_14_days += row.open_form_fills_7_to_14_days;
                existingWeek.open_form_fills_14_plus_days += row.open_form_fills_14_plus_days;
                existingWeek.average_age_days += row.average_age_days;
            } else {
                acc.push({
                    count: 1,
                    state: '',
                    week_start: row.week_start,
                    week_end: row.week_end,
                    open_form_fills_0_to_7_days: row.open_form_fills_0_to_7_days,
                    open_form_fills_7_to_14_days: row.open_form_fills_7_to_14_days,
                    open_form_fills_14_plus_days: row.open_form_fills_14_plus_days,
                    average_age_days: row.average_age_days
                });
            }

            return acc;
        }, [] as (PerformanceFormFillsDataResponse['backlog_reports'][number] & { count: number })[]);

        // Calculate averages
        for (const row of calculatedData) {
            row.average_age_days = row.average_age_days / row.count || 0;
        }

        calculatedData.sort(
            (a, b) => new Date(a.week_start).getTime() - new Date(b.week_start).getTime()
        );

        setProcessedData(calculatedData);
    }, [data, state]);

    return processedData || undefined;
};

export default useGetFormFillBacklogAgeing;
